module.exports = __webpack_public_path__ + "img/download-icon-active.7e3b3dd3.svg";